import React, { useState } from "react";

const PDF_CACHE = "pdf-files-v1";

const pdfList = [
    "/pdfs/slbphy27.pdf",
    "/pdfs/slbche27.pdf",
    "/pdfs/slbmath27.pdf"
];

const DownloadPDF = () => {
    const [downloaded, setDownloaded] = useState(0);
    const [downloading, setDownloading] = useState(false);
    const [complete, setComplete] = useState(false);

    const downloadPDFs = async () => {
        setDownloading(true);
        setDownloaded(0);
        setComplete(false);

        try {
            const cache = await caches.open(PDF_CACHE);

            for (const pdfUrl of pdfList) {
                const existing = await cache.match(pdfUrl);

                if (!existing) {
                    const response = await fetch(pdfUrl);

                    if (!response.ok) {
                        throw new Error(`Failed to download ${pdfUrl}`);
                    }

                    await cache.put(pdfUrl, response.clone());
                }

                setDownloaded((prev) => prev + 1);
            }

            setComplete(true);
        } catch (error) {
            console.error(error);
        } finally {
            setDownloading(false);
        }
    };

    return (
        <div>
            <br></br><br></br>
            <h2>Download Study PDFs</h2>

            <button
                onClick={downloadPDFs}
                disabled={downloading}
            >
                {downloading ? "Downloading..." : "Download PDFs"}
            </button>

            {downloading && (
                <p>
                    Downloading {downloaded} / {pdfList.length}
                </p>
            )}

            {complete && (
                <p>✓ All PDFs are ready for offline use.</p>
            )}

            <br></br><br></br><br></br>

            <a href="/pdfs/slbphy27.pdf" target="_blank" rel="noopener noreferrer">Phy</a> <br></br><br></br>
            <a href="/pdfs/slbche27.pdf" target="_blank" rel="noopener noreferrer">Che</a> <br></br><br></br>
            <a href="/pdfs/slbmath27.pdf" target="_blank" rel="noopener noreferrer">Math</a> <br></br><br></br>

            <br></br><br></br><br></br>
        </div>
    );
};

export default DownloadPDF;